
import { IonApp, IonFab, IonFabList, IonFabButton, IonRippleEffect, IonContent, IonIcon, IonItem, IonButton, IonLabel, IonButtons, IonHeader, IonMenuButton, IonTitle, IonToolbar, IonList, IonListHeader, IonMenu, IonMenuToggle, IonNote, IonPage, IonRouterOutlet, IonSplitPane, actionSheetController } from '@ionic/vue';
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { 
  shareSocialSharp,
  logoTwitter,
  closeSharp,
  listSharp
 } from 'ionicons/icons';
import toggleDarkTheme from './composables/toggleDarkTheme';

export default defineComponent({
  name: 'App',
  components: {
    IonPage,
    IonButton,
    IonApp, 
    IonContent, 
    IonIcon, 
    IonItem, 
    IonLabel, 
    IonList, 
    IonListHeader, 
    IonMenu, 
    IonMenuToggle, 
    IonNote, 
    IonRouterOutlet, 
    IonSplitPane,
    IonButtons,
    IonHeader,
    IonMenuButton,
    IonFab,
    IonFabList,
    IonFabButton,
    IonRippleEffect,
    IonTitle,
    IonToolbar
  },
  setup() {

    const presentShareActionSheet = async () => {
      const actionSheet = await actionSheetController
        .create({
          header: 'Share with?',
          buttons: [
            {
              text: 'Favorite',
              handler: () => {
                console.log('Favorite clicked')
              },
            },
            {
              text: 'Cancel',
              role: 'cancel',
              icon: closeSharp,
              handler: () => {
                //
              },
            },
          ],
        });
      return actionSheet.present();
    }
    
    onMounted(() => {

      const runOverAndOver = () => {
        //
        return requestAnimationFrame(runOverAndOver);
      };

      requestAnimationFrame(runOverAndOver);

      // Use matchMedia to check the user preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

      toggleDarkTheme(prefersDark.matches);

      // Listen for changes to the prefers-color-scheme media query
      prefersDark.addListener((mediaQuery) => toggleDarkTheme(mediaQuery.matches));

    });

    const getHref = () => window.location.href;

    const selectedIndex = ref(0);
    
    const route = useRoute();
    const store = useStore();
    const storeState = store.state;
    
    return { 
      listSharp,
      logoTwitter,
      shareSocialSharp,
      toggleDarkTheme,
      route,
      storeState,
      getHref,
      selectedIndex,
      presentShareActionSheet
    }
  }
});
